export default __webpack_public_path__ + "static/media/adduser.b2e4cbfb.svg";